import React from 'react';
import { Link } from 'react-router-dom';
import { PlayIcon, PauseIcon } from 'lucide-react';
import SaveToTracker from '../../components/UI/SaveToTracker';
import { useDarkMode } from '../../context/DarkModeContext';
import { usePlatform } from '../../context/PlatformContext';
import { handleImgError } from './constants';
interface BookCoverProps {
  book: any;
  isAudioPlaying: boolean;
  setIsAudioPlaying: (playing: boolean) => void;
}
export const BookCover = ({
  book,
  isAudioPlaying,
  setIsAudioPlaying
}: BookCoverProps) => {
  const {
    darkMode
  } = useDarkMode();
  const {
    isAfterTide
  } = usePlatform();
  return <div className="flex flex-col items-center" data-id="element-7837" data-mp="290scg7u002fi">
      <div className="relative w-48 sm:w-64" data-id="element-7838" data-mp="24ydtzou8r4or">
        <div className={`relative rounded-lg shadow-lg overflow-hidden ${darkMode ? 'shadow-black/30' : ''}`} data-id="element-7839" data-mp="24zf8y4edobbr">
          <img src={book.coverImage} alt={`Cover for ${book.title}`} className={`w-full aspect-[2/3] object-cover ${book.coming_soon ? 'opacity-90' : ''}`} onError={handleImgError} data-id="element-7840" data-mp="201dmralnnvw2" />
          {book.coming_soon && <div className="absolute top-0 right-0 bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg shadow-sm z-10" data-id="element-7841" data-mp="638v2nvm2ak">
              COMING SOON
            </div>}
        </div>
        <div className="absolute bottom-3 right-3" data-id="element-7842" data-mp="3nivvt21bp0ki">
          <SaveToTracker productId={book.id} data-id="element-7843" data-mp="f2u2swes6lss" />
        </div>
      </div>
      {/* Add to Cart & Wishlist Buttons */}
      <div className="mt-4 flex flex-col gap-3 w-full max-w-xs" data-id="element-7844" data-mp="j4fliydzxuaw">
        {/* Sample Buttons */}
      </div>
      {/* Compact Audiobook Listen Row */}
      {book.formats && book.formats.some((f: any) => f.type === 'Audiobook') && (() => {
      const audiobookFormat = book.formats.find((f: any) => f.type === 'Audiobook' && f.narrator);
      if (!audiobookFormat) return null;
      return <div className="mt-3 w-full max-w-xs" data-id="element-7845" data-mp="2urlzuxydzfki">
              <div className={`flex items-center gap-3 px-3 py-2.5 rounded-xl border ${darkMode ? 'bg-purple-900/20 border-purple-800' : 'bg-purple-50 border-purple-100'}`} data-id="element-7846" data-mp="2aru6tqp5czb2">
                {/* Mini cover with play overlay */}
                <button onClick={() => setIsAudioPlaying(!isAudioPlaying)} className="relative w-10 h-10 rounded-lg overflow-hidden flex-shrink-0 group/play" data-id="element-7847" data-mp="21wxoo8ng8cb2">
                  <img src={book.coverImage} alt="Audio sample" className="w-full h-full object-cover" data-id="element-7848" data-mp="1n29kcxtsbjx1" />
                  <div className={`absolute inset-0 flex items-center justify-center transition-opacity ${isAudioPlaying ? 'bg-black/50 opacity-100' : 'bg-black/40 opacity-0 group-hover/play:opacity-100'}`} data-id="element-7849" data-mp="1j293z7n4kync">
                    {isAudioPlaying ? <PauseIcon className="w-4 h-4 text-white fill-current" data-id="element-7850" data-mp="38d9la5amhm4j" /> : <PlayIcon className="w-4 h-4 text-white fill-current ml-0.5" data-id="element-7851" data-mp="3fx111nzi9ff8" />}
                  </div>
                  {isAudioPlaying && <div className="absolute inset-0 rounded-lg ring-2 ring-purple-500 ring-offset-1 ring-offset-transparent" data-id="element-7852" data-mp="3pp6r2s675mrs" />}
                </button>
                <div className="flex-1 min-w-0" data-id="element-7853" data-mp="2x0svsk6ht4jx">
                  <div className={`text-xs font-semibold truncate ${isAudioPlaying ? 'text-purple-500' : darkMode ? 'text-purple-300' : 'text-purple-900'}`} data-id="element-7854" data-mp="2x23zkjzxucb1">
                    Listen to Sample
                  </div>
                  <Link to={isAfterTide ? `/aftertide/narrator/${audiobookFormat.narrator!.toLowerCase().replace(/\s+/g, '-')}` : `/narrator/${audiobookFormat.narrator!.toLowerCase().replace(/\s+/g, '-')}`} className={`text-[11px] truncate block transition-colors ${darkMode ? 'text-purple-400 hover:text-purple-300' : 'text-purple-600 hover:text-purple-800'}`} data-id="element-7855" data-mp="3b0trll7whlsj">
                    Narrated by {audiobookFormat.narrator}
                  </Link>
                </div>
              </div>
            </div>;
    })()}
    </div>;
};
export default BookCover;